import { useState } from 'react';
import { useBegriffeSpeichern, useVerwaltungBegriffe } from '../hooks/data.js';
import { useToast } from '../state/toast.jsx';
import { Speichern } from './Speichern.jsx';

/**
 * Wörterbuch der Firma: Fachbegriffe umbenennen («Baustelle» → «Objekt»). Leeres Feld = Standard der Branche.
 * Die App übernimmt die Begriffe nach dem Speichern sofort.
 */
export function Begriffe({ online }) {
  const q = useVerwaltungBegriffe();
  const speichern = useBegriffeSpeichern();
  const toast = useToast();
  const [aenderungen, setAenderungen] = useState({});
  const [fehler, setFehler] = useState('');

  if (q.isError && !q.data) return <div className="empty" role="alert">{q.error.message}<button className="btn" onClick={() => q.refetch()}>Erneut versuchen</button></div>;
  if (!q.data) return <div className="skeleton" style={{ height: 240 }} />;

  const anzahl = Object.keys(aenderungen).length;
  const aendern = (b, text) => {
    setFehler('');
    setAenderungen((alt) => {
      const neu = { ...alt };
      if (text === (b.eigen ? b.wert : '')) delete neu[b.schluessel]; else neu[b.schluessel] = text;
      return neu;
    });
  };
  const absenden = async () => {
    setFehler('');
    try {
      await speichern.mutateAsync(Object.fromEntries(Object.entries(aenderungen).map(([k, v]) => [k, v.trim() || null])));
      setAenderungen({});
      toast({ text: 'Begriffe gespeichert – gelten ab sofort in der App' });
    } catch (err) {
      setFehler(err.message);
    }
  };

  return (
    <>
      <section className="card stack" style={{ gap: 16 }}>
        <p className="sub" style={{ fontSize: 14 }}>So heissen die Dinge in eurer App. Leer lassen = Standard (grau im Feld).</p>
        {q.data.begriffe.map((b) => {
          const id = `b-${b.schluessel}`;
          const wert = aenderungen[b.schluessel] ?? (b.eigen ? b.wert : '');
          return (
            <div key={b.schluessel} className="field">
              <label htmlFor={id} style={{ fontSize: 15, fontWeight: 800 }}>{b.standard}</label>
              <span className="sub" style={{ fontSize: 13 }}>{b.hilfe}</span>
              <input id={id} className="input" value={wert} maxLength={40} placeholder={b.standard} onChange={(ev) => aendern(b, ev.target.value)} />
            </div>
          );
        })}
      </section>
      <Speichern anzahl={anzahl} fehler={fehler} online={online} speichert={speichern.isPending}
        onVerwerfen={() => { setAenderungen({}); setFehler(''); }} onSpeichern={absenden} />
    </>
  );
}
